import { z } from "zod";

import type { User } from "@/types";

type AuthSession = {
  authToken: string;
  user: User;
};

export const loginResponseSchema = z
  .object({
    data: z.object({
      id: z.string(),
      email: z.email(),
      first_name: z.string(),
      last_name: z.string(),
      auth_token: z.string().min(1),
    }),
  })
  .transform<AuthSession>(({ data }) => {
    const firstName = data.first_name;
    const lastName = data.last_name;

    return {
      authToken: data.auth_token,
      user: {
        id: data.id,
        email: data.email,
        firstName,
        lastName,
        fullName: [firstName, lastName]
          .filter((namePart) => namePart !== "")
          .join(" "),
      },
    };
  });
